import { hasKey, removeLocalStorageCache, setLocalStorageCache, getLocalStorageCache, getConfigKey } from '@/utils/storageDataCacheNew'

class LocalStorageUtilsNew {
  /*
   * The configuration is saved as local shared object. So the value should
   * serializable to local storage.
   */
  static setConfiguration(key, value) {
    if (typeof value !== 'string') {
      value = JSON.stringify(value)
    }
    setLocalStorageCache(getConfigKey() + key, value, true)
  }
  static hasConfiguration(key) {
    return hasKey(getConfigKey() + key, true)
  }

  /*
    * The configuration is saved as local shared object. So the value should
    * serializable to local storage.
    */
  static getConfiguration(key, dataType = 'json') {
    const returnData = getLocalStorageCache(getConfigKey() + key, true, dataType !== 'string')
    return returnData
  }

  static removeConfiguration(key) {
    removeLocalStorageCache(getConfigKey() + key, true)
  }

  static getDelegationInfo() {
    return this.getConfiguration('delegationInfo')
  }
  static setDelegationInfo(delegation) {
    return this.setConfiguration('delegationInfo', delegation)
  }
  static clearDelegationInfo() {
    return this.removeConfiguration('delegationInfo')
  }
}
export default LocalStorageUtilsNew
